/*
 * Public API Surface of common
 */
// export default {};

export * from './dialogs';
